'use client';
import { Box, Stack } from '@/src/packages/components';
import { JournalEntryHeader } from './JournalEntryHeader';
import { IArticle } from '@/src/interfaces/generated/contentful';
import { JournalEntryRelated } from '@/src/packages/components/pages/JournalEntry/JournalEntryRelated';
import { JournalEntryBody } from '@/src/packages/components/pages/JournalEntry/JournalEntryBody';
import { useRef } from 'react';
import { NewsArticle } from 'schema-dts';
import { getRoute } from '@/src/packages/utils/routes';
import { paths } from '@/src/packages/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';
import { StoreConfig } from '@/src/store.config';
import {
  getArticleImageUrl,
  getFaviconUrl,
} from '@/src/packages/utils/routes/getRoute';

export const JournalEntry = ({
  article,
  related,
}: {
  article: IArticle;
  related: IArticle[];
}) => {
  const mainContentRef = useRef<HTMLDivElement>(null);

  const schema: NewsArticle = {
    '@type': 'NewsArticle',
    headline: article.fields.title,
    image: getArticleImageUrl({ article }),
    datePublished: article.fields.publicationDate,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': getRoute({
        route: paths.BLOG_SINGLE,
        params: { [pathParams.BLOG_SINGLE]: article?.fields.slug || '' },
        options: {
          format: 'absolute',
        },
      }),
    },
    publisher: {
      '@type': 'Organization',
      name: StoreConfig.site_name,
      logo: {
        '@type': 'ImageObject',
        url: getFaviconUrl(),
      },
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <Stack className="space-y-8">
        <JournalEntryHeader article={article} contentRef={mainContentRef} />
        <Box as="main" ref={mainContentRef}>
          <JournalEntryBody article={article} />
        </Box>
      </Stack>
      {related.length > 0 && <JournalEntryRelated articles={related} />}
    </>
  );
};
